import api from '@/plugins/api';

import FBody from '@/plugins/form/FBody';
import Direction from './Direction';
import Main from './Main';
import TourData from './TourData';
import Dates from './Dates';
import Tariffs from './Tariffs';
import Description from './Description';
import Services from './Services';

import component from './component.vue';

export default class TourAdminItem extends FBody {
  static get(id) {
    const item = new TourAdminItem();
    item.loading = true;
    return api.tour.admin
      .get({ id: +id })
      .then((data) => {
        item
          .setData(data)
          .init();
        return item;
      })
      .finally(() => {
        item.loading = false;
      });
  }

  component = component;

  id = null;

  __dontUseTariffs = false;

  main = null;

  direction = null;

  tourData = null;

  tariffs = null;

  services = null;

  dates = null;

  description = null;

  constructor(props = {}) {
    super(props);
    this.main = new Main({ parent: this });
    this.direction = new Direction({ parent: this });
    this.tourData = new TourData({ parent: this });
    this.tariffs = new Tariffs({ parent: this });
    this.services = new Services({ parent: this, tariffs: this.tariffs });
    this.dates = new Dates({ parent: this });
    this.description = new Description({ parent: this });
    this.setItems([
      ['direction', this.direction],
      ['main', this.main],
      ['tourData', this.tourData],
      ['dates', this.dates],
      ['description', this.description],
      ['tariffs', this.tariffs],
    ]);
  }

  get data() {
    const data =  {
      Tour: {
        IsActive: true,
        DontUseTariffs: this.dontUseTariffs,
        ...(this.id ? { Id: this.id } : {}),
        ...this.main.data,
        ...this.direction.data,
        ...this.tourData.data,
        ...this.description.data,
        Tariffs: this.tariffs.data,
        TourSchedule: this.dates.data,
        TourServices: this.services.data,
      },
    };
    console.log('get data', data)
    return data;
  }

  set dontUseTariffs(value){
    this.__dontUseTariffs = value;
    this.setDefaultTariff(value);
  }

  get dontUseTariffs(){
    return this.__dontUseTariffs;
  }

  setDefaultTariff(value) {
    if (value) {
      if (!this.tariffs.items.filter(i => i.isDefault).length)
        this.tariffs.addDefault();
      this.dates.addDefaultTariff(this.tariffs.items.filter(i => i.isDefault)[0]);
    } else {
      if (this.tariffs.items.filter(i => i.isDefault).length)
        this.dates.deleteDefaultTariff(this.tariffs.items.filter(i => i.isDefault)[0]);
    }
  }

  set data(data) {
    this.id = data?.Tour.Id || null;
    this.__dontUseTariffs = data?.Tour.DontUseTariffs || false;
    this.main.data = data?.Tour || {};
    this.direction.data = data?.Tour || {};
    this.tourData.data = data?.Tour || {};
    this.description.data = data?.Tour || {};
    this.tariffs.data = data?.Tour?.Tariffs || [];
    this.dates.data = data?.Tour?.TourSchedule || [];
    this.services.data = data?.Tour?.TourServices || [];
  }

  set(value = {}) {
    this.direction.set(value);
    this.main.set(value);
    this.tourData.set(value);
    this.dates.set(value);
    this.description.set(value);
    this.tariffs.set(value.tariffs);
    return this;
  }

  setData(value) {
    this.data = value;
    return this;
  }

  submit() {
     return super.submit()
       .then(() => this.api.tour.admin.set({ data: this.data }));
  }
}
